import { Obj, load } from "scrivito"
import { BuildingReferenceObj } from "scrivito/Objs/BuildingReference/BuildingReferenceObjClass"
import {
  ProductAttributes,
  ProductObj,
  ProductObjClass
} from "scrivito/Objs/Product/ProductObjClass"
import {
  ProductBaseVariantAttributes,
  ProductBaseVariantObj
} from "scrivito/Objs/ProductBaseVariant/ProductBaseVariantObjClass"
import { compareVariantKeys } from "shared/lib/variant-key/compareVariantKeys"

import { fetchBuildingReferencesByInstallationReferences } from "entities/building-references/api/fetchBuildingReferencesByInstallationReferences"
import { fetchInstallationReferencesByProducts } from "entities/building-references/api/fetchInstallationReferencesByProducts"
import { getProductType } from "entities/products/lib/getProductType"
import { isVariantKey } from "entities/products/lib/isVariantKey"

async function fetchMatchingProductsByVariantKey(variantKey: string) {
  if (!isVariantKey(variantKey)) {
    return []
  }

  const product = await load(() =>
    ProductObjClass.where(
      "productType",
      "equals",
      getProductType(variantKey)
    ).first()
  )

  const productBaseVariants =
    (await load(() => product?.children()))?.filter(child => {
      return (
        (compareVariantKeys(
          variantKey,
          child.get("variantKey")?.toString() ?? ""
        )?.matchedCount ?? 0) > 0
      )
    }) || []

  return [product, ...productBaseVariants].filter(Boolean) as Obj<
    ProductAttributes | ProductBaseVariantAttributes
  >[]
}

export async function fetchBuildingReferencesByVariantKey(
  variantKeys: string[]
): Promise<BuildingReferenceObj[]> {
  const products = (
    await Promise.all(
      variantKeys.map(variantKey =>
        fetchMatchingProductsByVariantKey(variantKey)
      )
    )
  ).flatMap(c => c)

  const installationReferences = await fetchInstallationReferencesByProducts(
    products as (ProductObj | ProductBaseVariantObj)[]
  )

  return fetchBuildingReferencesByInstallationReferences(
    installationReferences || []
  )
}
